import React, { useEffect, useState } from "react";
import { TableHeader } from "../../commons";
import TimesheetVsSchedulingMonthlyTableData from "./TimesheetVsSchedulingMonthlyTableData";
import { TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS, TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS } from "../../../constant/tableHeadersConstants/timeSheetConstants/timesheetVsSchedulingMonthlyReportConst";
import { daysBetween, daysBetweenDates } from "../../../utils/commonFunctions";
import { TimesheetVsSchedulingMonthlyListType } from "../../../redux/timeSheet/timeSheetType";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";

type AppProps = {
  data: TimesheetVsSchedulingMonthlyListType[] | [];
  offset: number;
  fetching: boolean;
  startDate: string;
  endDate: string;
  showBillable:boolean
  setHeader:any;
  header:any;
};

const TimesheetVsSchedulingMonthlyTable = ({
  data,
  offset,
  fetching,
  startDate,
  endDate,
  showBillable,
  setHeader,
  header

}: AppProps) => {
  const startDateParts = startDate.split("-").map(Number);
  const endDateParts = endDate.split("-").map(Number);
  // const [header, setHeader] = useState(showBillable?TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS:
  //   TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS
  // );
const [toggle ,setToggle] = useState(false)
  const startMonth = startDateParts[1] - 1;
  const endMonth = endDateParts[1] - 1;

  let numberOfDays = daysBetweenDates(startDate, endDate) + 1;

  const generateHeaders = (): JSX.Element[] => {
    const headers: JSX.Element[] = [];
    let monthsCount = endMonth - startMonth + 1;
    if (monthsCount < 0) {
      monthsCount = 12 + monthsCount;
    }
    for (let i = 0; i < monthsCount; i++) {
      // const year = startDateParts[2];
      const year = startDateParts[2] + Math.floor((startMonth + i) / 12); 
      const month = startMonth + i;
      const monthName = new Date(2022, month).toLocaleString("default", {
        month: "long",
      });
      headers.push(
        <th
          style={{ backgroundColor: "#e8ecf0" }}
          key={month}
          colSpan={showBillable?1:2}
          className={showBillable ? "text-left" : "text-center"}
          
        >
          {monthName} {year}
        </th>
      );
    }

    return headers;
  };
  

  useEffect(() => {
    if(!showBillable){
      setHeader([])



      if (numberOfDays < 32) {
        setHeader(TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS?.slice(0, 3));
      } else if (numberOfDays < 64) {
        setHeader(TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS?.slice(0, 5));
      } else {
        setHeader(TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS);
      }
    }
  }, [startMonth, endMonth,showBillable]);
  
   // For billable

   useEffect(() => {
    if(showBillable){
      setHeader([])

      if (numberOfDays < 32) {
        setHeader(TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS?.slice(0, 2));
      } else if (numberOfDays < 64) {
        setHeader(TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS?.slice(0, 3));
      } else {
        setHeader(TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS);
      }
    }
  }, [startMonth, endMonth , showBillable]);


  useEffect(()=>{
setToggle(!toggle)
  },[header])

  return (
    <div className="jobsType" style={{ overflowX: "scroll" }}>
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header-without-zinde">
          <tr className="new-table-head" style={{ fontSize: "11px" }}>
            <th style={{ backgroundColor: "#e8ecf0" }} className="text-left">
              Month
            </th>
            {generateHeaders()}
          </tr>
          <TableHeader tableHeader={header} />
        </thead>
        <tbody>
          <TimesheetVsSchedulingMonthlyTableData
            data={data}
            tableHeaders={header}
          />
           {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default TimesheetVsSchedulingMonthlyTable;
